"use client";

import { Page } from "@/sanity/sanity.types";
import { createContext, ReactNode, useContext, useState } from "react";

interface ILayoutContextProps {
  navOpen: boolean;
  setNavOpen: (open: boolean) => void;
  aiCalculatorData: Page | null;
  setAiCalculatorData: (data?: Page) => void;
}

interface ILayoutContextProviderProps {
  children: ReactNode;
}

const LayoutContext = createContext<ILayoutContextProps | null>(null);

const LayoutProvider = (props: ILayoutContextProviderProps) => {
  const { children } = props;
  const [navOpen, setNavOpen] = useState<boolean>(false);
  const [aiCalculatorData, setAiCalculatorData] = useState<Page | null>(null);

  const setAiCalculatorDataInternal = (data?: Page) => {
    setAiCalculatorData(data ?? null);
  };

  const contextValue = {
    navOpen,
    setNavOpen,
    aiCalculatorData,
    setAiCalculatorData: setAiCalculatorDataInternal,
  };

  return (
    <LayoutContext.Provider value={contextValue}>
      {children}
    </LayoutContext.Provider>
  );
};

export { LayoutProvider, LayoutContext };

export const useLayout = () => {
  const context = useContext(LayoutContext);

  if (!context) {
    throw new Error("useLayout must be used within an LayoutProvider");
  }

  return context;
};
